import logo from './logo.svg';
// import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Reservation from './pages/Reservation';
import PrivateRoute from './PrivateRoute';
import AdminLayout from './components/Layout/AdminLayout';
import Region from './pages/admin/Region/Region';
import Login from './pages/Login';
import Chu from './pages/admin/Chu/Chu';
import Service from './pages/admin/service/Service';
import AddUser from './pages/admin/Utilisateur/AddUser';
import Utilisateur from './pages/admin/Utilisateur/utilisateur';
import ReservationAdmin from './pages/admin/Reservation/Reservation'
import Profile from './pages/admin/Profile';
import AddReservation from './pages/admin/Reservation/AddReservation';
import ListService from './pages/admin/service/ListService';
import MainLayout from './components/Layout/MainLayout';
import Doleance from './pages/Doleance';
import DoleanceAdmin from './pages/admin/doleance/Doleance';
import Statisitique from './pages/admin/statistique/Statisitique';
import Ticket from './pages/admin/Reservation/Ticket';

function App() {
  return (
    <div >
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<MainLayout />}>
            <Route index element={<Reservation/>}></Route>
            <Route path='doleance' element={<Doleance/>}></Route>
          </Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/admin' element={<PrivateRoute><AdminLayout/></PrivateRoute>}>
            <Route index element={<Statisitique/>}></Route>
            <Route path='statistique' element={<Statisitique/>}></Route>
            <Route path='doleance' element={<DoleanceAdmin/>}></Route>
            <Route path='region' element={<Region/>}></Route>
            <Route path='chu' element={<Chu/>}></Route>
            <Route path='services' element={<Service/>}></Route>
            <Route path='users' element={<Utilisateur/>}></Route>
            <Route path='addUser' element={<AddUser/>}></Route>
            <Route path='reservation' element={<ReservationAdmin/>}></Route>
            <Route path='profile' element={<Profile />}></Route>
            <Route path='addReservation' element={<AddReservation />}></Route>
            <Route path='chuService' element={<ListService />}></Route>
            <Route path='ticket/:id' element={<Ticket />}></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
